import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import * as _ from "lodash";
import { BehaviorSubject, Observable } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

import { GridUtils } from "../../utils/gridUtils";
import {
  setAdvancedFilterQuery,
  setSimpleFilterQuery,
} from "../../utils/tableUtils";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class MovementService {
  public remoteData: BehaviorSubject<any[]>;
  private BASE_URL = this.appSession.baseUrl + "/api/v1/contractMovements";

  constructor(private http: HttpClient, private appSession: AppSessionService) {
    this.remoteData = new BehaviorSubject([]);
  }

  getMovement(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterLoadingActionQuery = localStorage.getItem("movementTypeDebit");
    let filterTransactionCodeQuery = localStorage.getItem("movementCode");

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (filterLoadingActionQuery && filterLoadingActionQuery.length > 0) {
      if (filterQuery && filterQuery.length > 0) {
        filterQuery = filterQuery.concat(
          " " + FilterOperation.AND + " (" + filterLoadingActionQuery + ")"
        );
      } else {
        filterQuery = filterQuery.concat(filterLoadingActionQuery);
      }
    }

    if (filterTransactionCodeQuery && filterTransactionCodeQuery.length > 0) {
      if (filterQuery && filterQuery.length > 0) {
        filterQuery = filterQuery.concat(
          " " + FilterOperation.AND + " (" + filterTransactionCodeQuery + ")"
        );
      } else {
        filterQuery = filterQuery.concat(filterTransactionCodeQuery);
      }
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.get(
      this.buildDataUrl(
        paging,
        filteringArgs,
        sortingArgs,
        headers,
        "/searchByContract?"
      ),
      { headers }
    );
  }

  updateMovement(movement): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(movement);
    const url = `${
      this.appSession.baseUrl +
      "/api/v1/contractMovements/updateContractMovement"
    }`;

    return this.http.post(url, data, { headers });
  }

  getMovements(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterLoadingActionQuery = localStorage.getItem("movementTypeDebit");
    let filterTransactionCodeQuery = localStorage.getItem("movementCode");

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (filterLoadingActionQuery && filterLoadingActionQuery.length > 0) {
      if (filterQuery && filterQuery.length > 0) {
        filterQuery = filterQuery.concat(
          " " + FilterOperation.AND + " (" + filterLoadingActionQuery + ")"
        );
      } else {
        filterQuery = filterQuery.concat(filterLoadingActionQuery);
      }
    }

    if (filterTransactionCodeQuery && filterTransactionCodeQuery.length > 0) {
      if (filterQuery && filterQuery.length > 0) {
        filterQuery = filterQuery.concat(
          " " + FilterOperation.AND + " (" + filterTransactionCodeQuery + ")"
        );
      } else {
        filterQuery = filterQuery.concat(filterTransactionCodeQuery);
      }
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.get(
      this.buildDataUrl(
        paging,
        filteringArgs,
        sortingArgs,
        headers,
        "/searchByContract?"
      ),
      { headers }
    );
  }

  public getByVehicleTransactionsList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders();

    let filterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    headers = headers.set(
      "Content-type",
      "application/x-www-form-urlencoded; "
    );

    const url = `${
      this.appSession.baseUrl + "/api/v1/contractMovements/searchByContract"
    }`;
    const vehicleCode = sessionStorage.getItem("vehicleCode");
    const sortedLoadingAction = sessionStorage.getItem("sortposDateDESC");

    if (sortingArgs && sortingArgs.length > 0) {
      sortingArgs.forEach((columnSorting, idx) => {
        if (idx < sortingArgs.length - 1) {
          orderQuery += GridUtils._buildSortExpression(columnSorting) + ";";
        } else {
          orderQuery += GridUtils._buildSortExpression(columnSorting);
        }
      });
    } else {
      orderQuery = sortedLoadingAction;
    }

    if (filterQuery?.length > 0) {
      filterQuery += `movementTypeCode=like='DEBIT' and debitMovement.vehicle.code == ${vehicleCode}`;
    } else {
      filterQuery = `movementTypeCode=like='DEBIT' and debitMovement.vehicle.code == ${vehicleCode}`;
    }

    if (filterQuery.length > 0) {
      headers = headers.append("query", filterQuery);
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.get(url, { headers });
  }

  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/contractMovements"
    }${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }
}
